import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function WhatWeWorkSection() {
  const items = ['Mentalidad y bloqueos emocionales', 'Seguridad para mostrarte y empezar', 'Cómo crear contenido que conecte y venda', 'Qué debe transmitir tu marca', 'Cómo vender sin perseguir personas', 'Historias que generan confianza y ventas', 'Revisión estratégica de Instagram', 'Claridad sobre qué hacer primero', 'Organización de tu negocio digital', 'Página web y estructura inicial digital'];
  return <section className="py-24 bg-brand-brown-light px-6" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-6 flex items-center justify-center gap-3" data-id="element-170">
            <span className="text-brand-gold text-2xl" data-id="element-171">✨</span>
            ¿Qué vas a lograr en la mentoría?
          </h2>
          <p className="text-lg text-brand-cream/70 font-light" data-id="element-172">
            Según tu etapa actual, podemos enfocarnos en:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-173">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="flex items-start gap-4 p-4 bg-brand-brown/40 border border-brand-gold/10 rounded-lg hover:bg-brand-brown/70 hover:border-brand-gold/30 transition-colors duration-300" data-id="element-174">
              <Sparkles className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-175" />
              <span className="text-brand-cream/90 font-light" data-id="element-176">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}